import React, { useState, useEffect } from "react";
import axios from 'axios';
import Particles from "react-particles-js";
import Socialicons from "../components/Socialicons";
import Layout from "../components/Layout";

const roles = [
  "Cloud Security Engineer",
  "GCP · AWS · Azure",
  "Terraform & IaC",
  "FedRAMP Compliance",
  "Kubernetes Enthusiast",
];

function Home(){
  const [information, setInformation] = useState("");
  const [typingText, setTypingText] = useState("");
  const [roleIndex, setRoleIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const particleConfig = {
    particles: {
      number: {
        value: 60,
        density: {
          enable: true,
          value_area: 900
        }
      },
      color: {
        value: "#00d4ff"
      },
      opacity: {
        value: 0.5,
        random: true
      },
      size: {
        value: 2.5,
        random: true
      },
      line_linked: {
        enable: true,
        distance: 160,
        color: "#00d4ff",
        opacity: 0.15,
        width: 1
      },
      move: {
        enable: true,
        speed: 1.2,
        direction: "none",
        random: true,
        straight: false,
        out_mode: "out",
        bounce: false
      }
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: true,
          mode: "grab"
        },
        resize: true
      },
      modes: {
        grab: {
          distance: 180,
          line_linked: {
            opacity: 0.5
          }
        }
      }
    }
  };

  useEffect(() =>{
    axios.get('/api/information')
    .then( response => {
      setInformation(response.data);
    })
  }, [])

  useEffect(() => {
    const currentRole = roles[roleIndex];
    const typingSpeed = isDeleting ? 40 : 80;
    const pauseBeforeDelete = 1800;
    const pauseBeforeType = 400;

    let timeout;

    if (!isDeleting && charIndex === currentRole.length) {
      timeout = setTimeout(() => setIsDeleting(true), pauseBeforeDelete);
    } else if (isDeleting && charIndex === 0) {
      timeout = setTimeout(() => {
        setIsDeleting(false);
        setRoleIndex((prev) => (prev + 1) % roles.length);
      }, pauseBeforeType);
    } else {
      timeout = setTimeout(() => {
        setCharIndex((prev) => prev + (isDeleting ? -1 : 1));
        setTypingText(currentRole.slice(0, charIndex + (isDeleting ? -1 : 1)));
      }, typingSpeed);
    }

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, roleIndex]);

  return (
    <Layout>
      <div className="mi-home-area mi-padding-section">
        <Particles className="mi-home-particle" params={particleConfig} />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12">
              <div className="mi-home-content">
                <div className="mi-home-terminal">
                  <div className="mi-home-terminal-bar">
                    <span className="mi-terminal-dot mi-terminal-dot-red"></span>
                    <span className="mi-terminal-dot mi-terminal-dot-yellow"></span>
                    <span className="mi-terminal-dot mi-terminal-dot-green"></span>
                    <p className="mi-terminal-title">~/james-maddox — bash</p>
                  </div>
                  <div className="mi-home-terminal-body">
                    <p className="mi-terminal-line">
                      <span className="mi-terminal-prompt">~/james-maddox</span>
                      <span className="mi-terminal-symbol"> $</span>
                      <span className="mi-terminal-cmd"> whoami</span>
                    </p>
                    <p className="mi-terminal-output">
                      <span className="mi-terminal-name">{information.name}</span>
                    </p>
                    <p className="mi-terminal-line">
                      <span className="mi-terminal-prompt">~/james-maddox</span>
                      <span className="mi-terminal-symbol"> $</span>
                      <span className="mi-terminal-cmd"> cat role.txt</span>
                    </p>
                    <p className="mi-terminal-output mi-terminal-typing">
                      {typingText}<span className="mi-terminal-cursor">▌</span>
                    </p>
                  </div>
                </div>
                <Socialicons bordered />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
